export class UserState {
  constructor() {
    this.userData = '';
  }
}
